//
//
//
//
//
//
//

import product from './components/visua';
import tableData from './components/table';
export default {
  components: {
    product: product,
    tableData: tableData
  },
  data: function data() {
    return {
      newCustomer: null
    };
  },
  mounted: function mounted() {},
  methods: {
    srectEd: function srectEd(value) {
      console.log(value);
      this.newCustomer = value;
    }
  }
};